import React from 'react'

const NavMenu = ({ children, ...props }) => (
	<nav role="navigation" aria-label="main navigation">
		<ul>{children}</ul>
	</nav>
)

export default NavMenu
